import { defineWizardStep, type WizardStep } from '@synqo/frontend-component-library';
import { type RequisitionWizardState } from '../../RequisitionWizardState';
import { type DetailsStepErrorKey, validateDetails } from './detailsErrors';
import { ExchangeStepBody, type ExchangeStepBodyProps } from './ExchangeStepBody';

interface DefineExchangeStepProps extends ExchangeStepBodyProps {
    i18n: (key: string) => string;
}

/** The step of an exchange: the container that goes, then the one that comes. */
// @ai-generated 2026-10-09T08:04:13+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function defineExchangeStep({
    i18n,
    ...bodyProps
}: DefineExchangeStepProps): WizardStep<RequisitionWizardState> {
    const { pickup, delivery } = bodyProps;

    return defineWizardStep<RequisitionWizardState, DetailsStepErrorKey>({
        key: 'exchange',
        label: i18n('Tauschen'),
        render: () => <ExchangeStepBody {...bodyProps} />,
        validate: () => {
            const missingContent = i18n('Bitte gib an, was in diesem Container ist.');
            const pickupErrors = validateDetails(
                pickup.position,
                i18n('Bitte wähle einen Container aus oder beschreibe ihn.'),
                missingContent,
            );

            return Object.keys(pickupErrors).length > 0
                ? pickupErrors
                : validateDetails(delivery.position, i18n('Bitte lege fest, was stattdessen kommt.'), missingContent);
        },
    });
}
